import { format } from 'date-fns'
import dayjs from 'dayjs'
class TimeUtils {
  static wait(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms))
  }

  static getToday(formatType: string = 'yyyy-MM-dd'): string {
    const today = new Date()
    today.setHours(0, 0, 0, 0)

    return format(today, formatType)
  }

  static getYesterday(formatType: string = 'yyyy-MM-dd'): string {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    today.setDate(today.getDate() - 1)
    return format(today, formatType)
  }

  static getOneYearAgo(formatType: string = 'yyyy-MM-dd'): string {
    const today = new Date()
    today.setFullYear(today.getFullYear() - 1)

    return format(today, formatType)
  }

  // * RETURNS DAYJS DATE INSTEAD OF DATE FNS
  static getOneYearAgoDayJS(formatType: string = 'YYYY-MM-DD'): string {
    return dayjs(new Date()).subtract(1, 'year').format(formatType)
  }

  static getYesterdayDayJS(formatType: string = 'YYYY-MM-DD'): string { 
    return dayjs(new Date()).subtract(1, 'day').format(formatType)
  }
}

export { TimeUtils }
